<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'participationModule.participations' | translate }}
    </h3>
    <button
      type="button"
      class="btn btn-sm btn-primary"
      (click)="onClickCreateParticipation()"
    >
      {{ 'general.add' | translate }}
      <span *ngIf="selectedBookingCanOverbook">
        {{ ' ' }} {{ 'bookingModule.toWaitingList' | translate }}</span
      >
    </button>
  </div>
  <div class="card-body pb-0">
    <fieldset class="mb-3">
      <legend class="form-label">
        {{ 'participationModule.showLastBookingParticipants' | translate }}
      </legend>
      <div class="btn-group-segment">
        <input
          data-test-id="show-last-booking-participants-toggle"
          type="radio"
          class="btn-check"
          name="onlyLastBookingParticipants"
          value="{{ true }}"
          (click)="setOnlyLastBookingParticipants(true)"
          id="onlyLastBookingParticipantsbtnradio1"
          autocomplete="off"
          [checked]="onlyLastBookingParticipants"
        />
        <label class="btn btn-sm" for="onlyLastBookingParticipantsbtnradio1">
          {{ 'general.yes' | translate }}
        </label>

        <input
          data-test-id="not-show-last-booking-participants-toggle"
          type="radio"
          class="btn-check"
          name="onlyLastBookingParticipants"
          id="onlyLastBookingParticipantsbtnradio2"
          value="{{ false }}"
          (click)="setOnlyLastBookingParticipants(false)"
          autocomplete="off"
          [checked]="!onlyLastBookingParticipants"
        />
        <label class="btn btn-sm" for="onlyLastBookingParticipantsbtnradio2">
          {{ 'general.no' | translate }}
        </label>
      </div>
    </fieldset>

    <div class="alert alert-primary mb-0" role="alert" aria-atomic="true">
      <i
        class="fas fa-info-circle flex-shrink-0"
        role="img"
        aria-hidden="true"
      ></i>
      <span>
        {{ 'participationModule.lastBookingParticipantsInfo' | translate }}
      </span>
    </div>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="card-body pt-0">
    <div
      class="d-flex justify-content-center align-items-center min-vh-100"
      *ngIf="isLoading$ | async"
    >
      <div class="spinner-border" role="status" attr.aria-label="loading"></div>
    </div>

    <participation-general-table
      [tableData]="participations$ | async"
      [bulkActions]="[BulkAction.DELETE]"
      (onBulkAction)="onBulkAction($event)"
      (onViewBookings)="onViewBookings($event)"
      class="d-block card-table"
      [generalOptions]="{ hideChecked: false, showViewBookings: true }"
    ></participation-general-table>
  </div>

  <!-- End Body -->
</section>
<!-- End Card -->
